import React, {Component} from 'react';
import {
    StyleSheet,
    Text,
    View, processColor, Platform
} from 'react-native';

import i18n from "../../I18n/i18n";
import {moderateScale} from "../../tools/Scaling";
import * as Colors from "../../tools/Colors";
import {typeExport} from "../../redux/store/type";
import {Line, defaults} from '@reactchartjs/react-chart.js'
import HMTextView from "../HMTextView";

const data = {
    labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر'],

    datasets: [
        {
            label: 'منطقه ۱',
            data: [12, 19, 3, 5, 2, 3],
            // backgroundColor: 'rgb(255, 99, 132)',
            backgroundColor: Colors.transparent,
            borderColor: "#ee5d0c",
            yAxisID: 'y-axis-1',
            fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,
            lineTension: 0,


        },
        {
            label: 'منطقه ۲',
            data: [2, 3, 20, 5, 1, 4],
            borderColor: "#0076ad",
            //backgroundColor: 'rgba(53, 162, 235, 0.5)',
            backgroundColor: Colors.transparent,
            yAxisID: 'y-axis-2',
            lineTension: 0,

        },
        {
            label: 'منطقه ۳',
            data: [20, 30, 8, 12, 9, 1],
            borderColor: "#20b331",
            //  backgroundColor: 'rgba(50, 50, 8, 0.5)',
            backgroundColor: Colors.transparent,
            yAxisID: 'y-axis-2',
            lineTension: 0,

        },

    ],
}

export const options = {
    bezierCurve: false,
    legend: {
        labels: {
            usePointStyle: true,
            boxWidth: moderateScale(10),
            //  fontSize: moderateScale(14)
        }
    },
    font: {family: i18n.locale == 'en' ? null : typeExport.regularFontName},
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
        mode: 'index',
        intersect: false,

    },
    stacked: false,
    plugins: {
        title: {
            display: true,
            text: 'نمودار',
        },
    },
    scales: {

        // yAxis: {
        //     left: {
        //         //fontFamily: "IRANSansMobile(FaNum)_Bold",
        //         fontFamily: i18n.locale == 'en' ? typeExport.regularFontName : typeExport.regularFontName,
        //
        //         axisLineColor: processColor(Colors.colorSecondPrimary),
        //         gridColor: processColor(Colors.colorPrimary),
        //         // labelCount:      6,
        //         labelCountForce: true,
        //         textSize: 14,
        //         axisMinimum: 0,
        //
        //     }
        // },
        yAxes: [
            {
                id: 'y-axis-1',

                type: 'linear',
                display: true,
                position: 'left',
                fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,
                fontWeight: "bold",

                ticks: {
                    beginAtZero: true,
                },

            },
            {
                id: 'y-axis-2',
                type: 'linear',
                display: false,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                },
                fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,
                fontWeight: "bold",
            },
        ],

        // y: {
        //     type: 'linear',
        //     display: true,
        //     position: 'left',
        // },
        // y1: {
        //     type: 'linear',
        //     display: true,
        //     position: 'right',
        //     grid: {
        //         drawOnChartArea: false,
        //     },
        // },
    },

};


export default class HMLineChart extends Component {
    constructor(props) {
        super(props);
        defaults.global.defaultFontFamily = typeExport.regularFontName;

        let item = props.item;
        /*      let item = [
                  {
                      "YM": {
                          "Year": 1399,
                          "Month": 7
                      },
                      "MONTH": "24 روز از مهرماه",
                      "IN": 36189293752,
                      "OUT": 3287908317,
                      "CREDITUSED": 144580.04425626755,
                      "BEGINDATE": "1399\/7\/1",
                      "ENDDATE": "1399\/7\/24"
                  },
                  {
                      "YM": {
                          "Year": 1399,
                          "Month": 6
                      },
                      "MONTH": "شهریور",
                      "IN": 39809241505,
                      "OUT": 5339810025,
                      "CREDITUSED": 169129.65653301237,
                      "BEGINDATE": "1399\/6\/1",
                      "ENDDATE": "1399\/6\/31"
                  },
                  {
                      "YM": {
                          "Year": 1399,
                          "Month": 5
                      },
                      "MONTH": "مرداد",
                      "IN": 41768774920,
                      "OUT": 3062643313,
                      "CREDITUSED": 164538.76142395969,
                      "BEGINDATE": "1399\/5\/1",
                      "ENDDATE": "1399\/5\/31"
                  }
              ];*/


        let arr = [];
        let arrayX = [];
        let arrayYA = [];
        let arrayYB = [];


        // for (let i = 0; i < item.length; i++) {
        //     let arrY = [];
        //     arrY.push(Tools.convertOnlyGig(item[i].OUT))
        //     arrY.push(Tools.convertOnlyGig(item[i].IN))
        //
        //     arrayYA.push(Tools.convertOnlyGig(item[i].OUT))
        //     arrayYB.push(Tools.convertOnlyGig(item[i].IN))
        //
        //     arrayX.push(item[i].MONTH)
        //     arr.push({
        //         y: arrY,
        //         marker: ["ارسال", "دریافت"]
        //     })
        // }
        let type = "bold";

        /*
                const data = {
                    labels: ['1', '2', '3', '4', '5', '6'],
                    datasets: [
                        {
                            label: '# of Red Votes',
                            data: [12, 19, 3, 5, 2, 3],
                            backgroundColor: 'rgb(255, 99, 132)',
                        },
                        {
                            label: '# of Blue Votes',
                            data: [2, 3, 20, 5, 1, 4],
                            backgroundColor: 'rgb(54, 162, 235)',
                        },
                        {
                            label: '# of Green Votes',
                            data: [3, 10, 13, 15, 22, 30],
                            backgroundColor: 'rgb(75, 192, 192)',
                        },
                    ],
                }
                */
        this.state = {
            dataBar: {
                labels: arrayX,
                datasets: [
                    {
                        label: 'ترافیک مصرفی',
                        data: arrayYA,
                        backgroundColor: 'rgb(255, 99, 132)',
                    },
                    {
                        label: 'اعتبار مصرفی',
                        data: arrayYB,
                        backgroundColor: 'rgb(54, 162, 235)',
                    },
                    /*      {
                              label: '# of Green Votes',
                              data: [3, 10, 13, 15, 22, 30],
                              backgroundColor: 'rgb(75, 192, 192)',
                          },*/
                ],
            },
            dataChart: props.dataChart ? props.dataChart : data,
            // dataChart: data,


            legend: {
                enabled: true,
                textSize: moderateScale(14),
                form: "SQUARE",
                formSize: moderateScale(14),
                xEntrySpace: moderateScale(10),
                yEntrySpace: moderateScale(5),
                wordWrapEnabled: true,
                fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,

            },
            data: {
                dataSets: [{


                    // values: [
                    //     {y: [40, 30], marker: ["", "row2"]},
                    //     {y: [10, 20], marker: "second"},
                    //     {y: [30, 20], marker: ["hello", "world"]}
                    // ],


                    values: arr,


                    label: '',
                    // config: {
                    //     colors: [processColor('#C0FF8C'), processColor('#FFF78C'), processColor('#FFD08C')],
                    //     stackLabels: ['دریافت', 'ارسال', 'اعتبار مصرفی'],
                    // }
                    config: {

                        fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,

                        valueTextSize: moderateScale(12),
                        colors: [processColor("#009bee"), processColor("#ee5a5d")],
                        stackLabels: ["ارسال", "دریافت"],
                    }
                }],
            },
            // highlights: [{x: 1, stackIndex: 2}, {x: 2, stackIndex: 1}],
            xAxis: {
                fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,

                valueFormatter: arrayX,
                textSize: moderateScale(13),
                granularityEnabled: true,
                granularity: 1

            },
            // xAxis: {
            //     valueFormatter: ['1998', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007'],
            //     granularityEnabled: true,
            //     granularity : 1,
            //     enabled: true,
            //     drawLabels: true,
            //     drawAxisLine: false,
            //     drawGridLines: false,
            // },
            yAxis: {

                left: {
                    fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,

                    axisLineColor: processColor(Colors.colorSecondPrimary),
                    gridColor: processColor(Colors.colorPrimary),
                    // labelCount:      6,
                    labelCountForce: true,
                    textSize: moderateScale(13),

                },
                right: {
                    fontFamily: i18n.locale == 'en' ? null : typeExport.regularFontName,

                    enabled: false,
                    drawLabels: true,
                    drawAxisLine: true,
                    axisLineColor: processColor(Colors.colorPrimaryDark),
                    drawGridLines: false,
                }
            }

        };
    }

    handleSelect(event) {
        let entry = event.nativeEvent
        if (entry == null) {
            this.setState({...this.state, selectedEntry: null})
        } else {
            this.setState({...this.state, selectedEntry: JSON.stringify(entry)})
        }

    }

    render() {
        // let jsfiddleUrl = 'https://jsfiddle.net/alidingling/30763kr7/';
        let {title, styleTitle, styleRootTitle} = this.props;

        return (

            <View style={{
                flex: 1
            }}>

                {/*<View style={{height: moderateScale(80)}}>*/}
                {/*<Text> selected entry</Text>*/}
                {/*<Text> {this.state.selectedEntry}</Text>*/}
                {/*</View>*/}

                <View style={styles.container}>
                    {title ?
                        <HMTextView
                            //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                            text={title}
                            //  text={"ثبت و بستن تیکت"}
                            type={"bold"}
                            style={[{
                                fontSize: moderateScale(16),
                                marginVertical: moderateScale(2),
                                //     marginHorizontal: moderateScale(4),
                                color: Colors.blackLight
                            }, styleTitle]}
                            styleRoot={[{alignSelf: "center"}, styleRootTitle]}
                        />
                        :
                        null
                    }
                    {/*  <BarChart
                        style={styles.chart}
                        xAxis={this.state.xAxis}
                        yAxis={this.state.yAxis}
                        data={this.state.data}
                        legend={this.state.legend}
                        drawValueAboveBar={true}
                        chartDescription={{text: ''}}

                        marker={{
                            enabled: true,
                            markerColor: processColor('#F0C0FF8C'),
                            textColor: processColor('white'),
                            markerFontSize: moderateScale(14),
                        }}
                        highlights={this.state.highlights}
                        onSelect={this.handleSelect.bind(this)}
                        onChange={(event) => {}}


                        // animation={{durationX: 2000}}
                        // gridBackgroundColor={processColor('#000000')}
                        // visibleRange={{x: { min: 5, max: 5 }}}
                        // drawBarShadow={false}
                        // drawHighlightArrow={true}


                    />*/}
                    {/*
                      <StackedBarChart
                          style={{ height: "94%" }}
                          keys={keys}
                          colors={colors}
                          data={data}
                          showGrid={false}
                          contentInset={{ top: 100, bottom: 100 }}
                        //  valueAccessor={({ item, key }) => item[key].value}

                      />*/}
                    <Line data={this.props.dataChart ? this.props.dataChart : this.state.dataChart} options={options}

                          style={styles.chart}
                    />

                </View>

            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        // width: "100%",
        // height: "100%",
        backgroundColor: '#fff'
        , paddingVertical: moderateScale(10)
        , paddingHorizontal: moderateScale(4)
    },
    chart: {
        flex: 1
    }
});
